import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.div`
    ${({ height }) => `height: ${height};`}
    ${({ width }) => `width: ${width};`}
  ${({ nolimits }) =>
        !nolimits &&
        `
      max-height: 80vh;
      max-width: 80vh;
    `}
`

function Box(props) {
    const { children, ...rest } = props
    return <Wrapper {...rest}>{children}</Wrapper>
}

Box.propTypes = {
    children: PropTypes.node.isRequired,
    height: PropTypes.string,
    nolimits: PropTypes.bool,
    width: PropTypes.string,
}

Box.defaultProps = {
    height: '100%',
    nolimits: false,
    width: '100%',
}

export default Box
